/**
 * @generated SignedSource<<28e7622edc79952ebafcab84c0dbe029>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type createPersonalizedNotificationTemplateButton_PersonalizedNotificationTemplateFragment$data = {
  readonly Admin: {
    readonly Notification: {
      readonly GetAvailableNotificationTemplates: ReadonlyArray<{
        readonly key: string;
        readonly title: string;
      }>;
    };
  };
  readonly " $fragmentType": "createPersonalizedNotificationTemplateButton_PersonalizedNotificationTemplateFragment";
};
export type createPersonalizedNotificationTemplateButton_PersonalizedNotificationTemplateFragment$key = {
  readonly " $data"?: createPersonalizedNotificationTemplateButton_PersonalizedNotificationTemplateFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"createPersonalizedNotificationTemplateButton_PersonalizedNotificationTemplateFragment">;
};

import createPersonalizedNotificationTemplateButton_Refetch_graphql from './createPersonalizedNotificationTemplateButton_Refetch.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": createPersonalizedNotificationTemplateButton_Refetch_graphql
    }
  },
  "name": "createPersonalizedNotificationTemplateButton_PersonalizedNotificationTemplateFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AdminQueryType",
      "kind": "LinkedField",
      "name": "Admin",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "NotificationAdminSchema",
          "kind": "LinkedField",
          "name": "Notification",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "NotificationTemplate",
              "kind": "LinkedField",
              "name": "GetAvailableNotificationTemplates",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "key",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "b5255375ff27ca3cbbdf589cdeb0a1d9";

export default node;
